import { useState } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { fetchCalendlyEventTypes } from '../services/meetings.service';

export interface CalendlyEvent {
  uri: string;
  name: string;
  duration: number;
  kind: string;
  scheduling_url: string;
}

interface CalendlyIntegrationState {
  calendlyEvents: CalendlyEvent[];
  isCalendlyLoading: boolean;
  calendlyError: string | null;
  selectedCalendlyUrl: string;
  setSelectedCalendlyUrl: (url: string) => void;
  fetchCalendlyEvents: () => Promise<void>;
  handleCalendlyEventSelect: (e: SelectChangeEvent<string>) => void;
  resetCalendly: () => void;
}

export const useCalendlyIntegration = (): CalendlyIntegrationState => {
  const [calendlyEvents, setCalendlyEvents] = useState<CalendlyEvent[]>([]);
  const [isCalendlyLoading, setIsCalendlyLoading] = useState(false);
  const [calendlyError, setCalendlyError] = useState<string | null>(null);
  const [selectedCalendlyUrl, setSelectedCalendlyUrl] = useState('');

  const fetchCalendlyEvents = async () => {
    setIsCalendlyLoading(true);
    setCalendlyError(null);
    try {
      const res: any = await fetchCalendlyEventTypes();
      if (res.success && Array.isArray(res.data)) {
        setCalendlyEvents(res.data);
      }
    } catch (err: any) {
      if (err.code === 'CALENDLY_NOT_CONNECTED' || err.message?.includes('not connected')) {
        setCalendlyError('not_connected');
      } else {
        setCalendlyError('Failed to load event types.');
      }
    } finally {
      setIsCalendlyLoading(false);
    }
  };

  const handleCalendlyEventSelect = (e: SelectChangeEvent<string>) => {
    setSelectedCalendlyUrl(e.target.value);
  };

  const resetCalendly = () => setSelectedCalendlyUrl('');

  return {
    calendlyEvents,
    isCalendlyLoading,
    calendlyError,
    selectedCalendlyUrl,
    setSelectedCalendlyUrl,
    fetchCalendlyEvents,
    handleCalendlyEventSelect,
    resetCalendly,
  };
};
